import { useState } from "react";
import axios from "axios";
import { REACT_APP_API_PORT } from "../../Api";

const useNewsletter = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading1, setIsLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const res = await axios.post(
        `${REACT_APP_API_PORT}user/auth/add-newsletter-subscriber`,
        { email }
      );

      if (res.data.status) {
        setEmail("");
        setMessage({ type: "success", text: "Subscribed successfully!" });
      }
    } catch (err) {
      setMessage({
        type: "error",
        text: err?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    setEmail,
    message,
    isLoading1,
    subscribe,
  };
};

export default useNewsletter;
